import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { useCallback } from "react";
import UserBooks from "./UserBooks";
import UserRights from "./UserRights";
import UserSettings from "./UserSettings";

import { useUserRights } from "../../../contexts/UserRightsContext";
import UserLanguages from "./UserLanguages";
import UserLineTypeLinks from "./UserLineTypeLinks";
import "./UserTabs.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index || props.hidden}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ProfileTabs(props) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );
  //const user = useContext(UserContext);
  console.log("", props);
  return (
    <React.Fragment>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        className="w-full mb-2 overflow-x-scroll tabs-class"
      >
        <Tab label="General" {...a11yProps(0)} />
        <Tab label="Rights" {...a11yProps(1)} hidden={!hasRights(346)} />
        <Tab label="Books" {...a11yProps(2)} hidden={!hasRights(335)} />
        <Tab label="Languages" {...a11yProps(3)} hidden={!hasRights(469)} />
        <Tab label="Line Types" {...a11yProps(4)} hidden={!hasRights(346)} />
      </Tabs>
      <hr className="my-2" />
      <TabPanel className="tab-content" value={value} index={0}>
        <UserSettings
          sysUser={props.sysUser}
          UpdateSysUser={props.UpdateSysUser}
        ></UserSettings>
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={1}
        hidden={!hasRights(346)}
      >
        <UserRights
          sysUser={props.sysUser}
          UpdateSysUser={props.UpdateSysUser}
        ></UserRights>
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={2}
        hidden={!hasRights(335)}
      >
        <UserBooks
          sysUser={props.sysUser}
          UpdateProfile={props.UpdateProfile}
        ></UserBooks>
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={3}
        hidden={!hasRights(469)}
      >
        <UserLanguages sysUser={props.sysUser}></UserLanguages>
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={4}
        hidden={!hasRights(325)}
      >
        <UserLineTypeLinks sysUser={props.sysUser}></UserLineTypeLinks>
      </TabPanel>
    </React.Fragment>
  );
}
